//$(".readonly :input").attr("readonly", true);

//$(".readonly :input").not('input[id="#event_attendee_credentials_id"]').attr("readonly", true);

//$("input[id='#event_attendee_credentials_id']").attr("readonly", false);

$(document).on('click', 'a[id=check_in]' ,function(){
    var gift_option = this.value;
    var attendee_id = $('#attendee_info').data('attendee-id');
    var credentials_id = $('#event_attendee_credentials_id').val();
    $.get(`/event_attendee/checkin_attendee?event_attendee_id=${attendee_id}&credentials_id=${credentials_id}`);
    // var inputValue = $(this).attr("value");
    // var className = $(this).attr("class");
    // var attendee_info = $(this).closest("[id*=attendee_info]");


    // attendee_info.find(".rep-container").addClass('d-none');
    // attendee_info.find(".self-container").addClass('d-none');
    // attendee_info.find(".guest-container").addClass('d-none');
    // containerClass = inputValue+ "-container";

    // attendee_info.find("."+containerClass).removeClass('d-none');
});

